require('./angular-sanitize');
module.exports = 'ngSanitize';



//////////////////
// WEBPACK FOOTER
// ./~/angular-sanitize/index.js
// module id = 994
// module chunks = 1